import React, { useState } from 'react';

import DashboardHeader from '../components/DashboardHeader';
import MetricBoxes from '../components/MetricBoxes';
import ContinueReading from '../components/ContinueReading';
import DashboardQuests from '../components/DashboardQuests';
import HeroPromoBanner from '@/features/library/components/HeroPromoBanner';
import { useSubscriptionStatus } from '@/features/library/hooks/useSubscriptionStatus';
import SubscriptionPaywallModal from '../components/SubscriptionPaywallModal';

const Dashboard: React.FC = () => {
  const [continueStatus, setContinueStatus] = useState({
    hasBooks: true,
    isLoading: true,
  });
  const { isSubscriptionActive, isLoading: subscriptionLoading } = useSubscriptionStatus();

  return (
    <div className="min-h-screen bg-white pt-safe-top" dir="rtl">
      {/* Header */}
      <div className="mt-2">
        <DashboardHeader />
      </div>

      {/* Main Content */}
      <div className="-mt-1 sm:-mt-1 px-2 sm:px-3 space-y-[14px] sm:space-y-[19px] pb-8">
        {/* Metric Boxes - Daily Reading Time & Weekly Streak */}
        <MetricBoxes />

        {/* Premium Banner - Show if not subscribed */}
        {!subscriptionLoading && !isSubscriptionActive && (
          <HeroPromoBanner location="dashboard" />
        )}

        {/* Continue Reading */}
        <div>
          <h2 className="font-persian font-bold text-base sm:text-lg mb-[4px] sm:mb-[6px] text-right text-gray-800 pr-2">
            {continueStatus.isLoading ? (
              <span className="inline-block h-5 w-24 rounded bg-gray-200 animate-pulse align-middle" />
            ) : continueStatus.hasBooks ? (
              'ادامه بده'
            ) : (
              'کتاب های پیشنهادی'
            )}
          </h2>
          <ContinueReading onStatusChange={setContinueStatus} />
        </div>

        {/* Daily Quests Section */}
        <div>
          <DashboardQuests />
        </div>
      </div>

      <SubscriptionPaywallModal />
    </div>
  );
};

export default Dashboard;
